import { gql } from 'graphql-tag';

export const getOrganisationCustomFields = gql`
  query GetOrganisationCustomFields(
    $input: GetOrganisationCustomFieldsInputType
  ) {
    getOrganisationCustomFields(input: $input) {
      customFields {
        id
        label
        identifier
        description
        fieldType
        status
        displayOrder
        options
        optionDetails {
          id
          customFieldId
          label
          displayOrder
          isActive
          createdAt
          updatedAt
        }
        sectionId
        isStandard
        author {
          id
          name
        }
        createdAt
        updatedAt
      }
      total
    }
  }
`;

export const createCustomField = gql`
  mutation CreateCustomField($input: CreateCustomFieldInputType!) {
    createCustomField(input: $input) {
      id
      label
      identifier
      description
      fieldType
      status
      displayOrder
      options
      sectionId
      isStandard
      createdAt
      updatedAt
    }
  }
`;

export const updateCustomField = gql`
  mutation UpdateCustomField($input: UpdateCustomFieldInputType!) {
    updateCustomField(input: $input) {
      id
      label
      identifier
      description
      fieldType
      status
      displayOrder
      options
      sectionId
      isStandard
      createdAt
      updatedAt
    }
  }
`;

export const reorderCustomFields = gql`
  mutation ReorderCustomFields($input: ReorderCustomFieldsInputType!) {
    reorderCustomFields(input: $input) {
      id
      displayOrder
    }
  }
`;

export const deactivateCustomField = gql`
  mutation DeactivateCustomField($input: DeactivateCustomFieldInputType!) {
    deactivateCustomField(input: $input)
  }
`;

export const updateCustomFieldOptions = gql`
  mutation UpdateCustomFieldOptions(
    $input: UpdateCustomFieldOptionsInputType!
  ) {
    updateCustomFieldOptions(input: $input) {
      id
      customFieldId
      label
      displayOrder
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const reactivateCustomField = gql`
  mutation ReactivateCustomField($input: ReactivateCustomFieldInputType!) {
    reactivateCustomField(input: $input)
  }
`;
